// extracted by mini-css-extract-plugin
export var addButton = "_n7-0";
export var border = "_n7-8";
export var check = "_n7-h";
export var danger = "_n7-6";
export var dropdownContainer = "_n7-1";
export var editModalBody = "_n7-j";
export var footerContainer = "_n7-i";
export var fullWidth = "_n7-a";
export var hide = "_n7-9";
export var icon = "_n7-3";
export var input = "_n7-7";
export var inputFlex = "_n7-b";
export var inputWrapper = "_n7-c";
export var manualFocus = "_n7-5";
export var optionButton = "_n7-4";
export var pillWrapper = "_n7-e";
export var pointer = "_n7-2";
export var showOverflow = "_n7-f";
export var tagsFlex = "_n7-d";
export var xButton = "_n7-g";